/**
 * Cell CSS class helpers used by the row templates: strength of schedule, injury risk, floor
 * and ceiling pills.
 *
 * Calls on sibling mixins via `this`: none.
 */
import {
    getPercentLowLevel,
    getPercentLowLevelText,
    getPercentHighLevel,
    getPercentHighLevelText,
    getFloorPoints,
    getCeilingPoints,
} from './../../helpers/ProjectionGenericHelper.js';
import { getInjuryRiskClass as resolveInjuryRiskClass } from './../../helpers/RankingsHelper.js';
import { getAgainstPercentageField, getAvgRemainingSosBgClass, getSosTextClass } from './../../helpers/StrengthOfScheduleHelper.js';

export default () => ({
    lowRangePoints: {},
    highRangePoints: {},
    strengthOfSchedule: [],

    // Helpers
    dsHelper: null,
    rankingsHelper: null,

    initCellClassHelpers() {
        this.dsHelper = {
            getPercentLowLevel,
            getPercentLowLevelText,
            getPercentHighLevel,
            getPercentHighLevelText,
            getFloorPoints,
            getCeilingPoints,
        };

        this.rankingsHelper = {
            getAgainstPercentageField,
            getAvgRemainingSosBgClass,
            getSosTextClass,
        };
    },

    getAvgRemainingSosClass(teamId, fantasyPosition) {
        if (!this.rankingsHelper || !this.strengthOfSchedule.length) {
            return '';
        }
        const teamSosData = this.strengthOfSchedule.find(sosData => sosData.team_id === teamId);
        if (!teamSosData) {
            return '';
        }
        const againstPctField = this.rankingsHelper.getAgainstPercentageField(fantasyPosition);
        return this.rankingsHelper.getAvgRemainingSosBgClass(teamSosData[againstPctField]);
    },
    getSosClass(teamId, fantasyPosition) {
        if (!this.rankingsHelper || !this.strengthOfSchedule.length) {
            return '';
        }
        const teamSosData = this.strengthOfSchedule.find(sosData => sosData.team_id === teamId);
        if (!teamSosData) {
            return '';
        }
        const againstPctField = this.rankingsHelper.getAgainstPercentageField(fantasyPosition);
        return this.rankingsHelper.getSosTextClass(teamSosData[againstPctField]);
    },
    getInjuryRiskClass(positionalRiskGroup) {
        return resolveInjuryRiskClass(positionalRiskGroup);
    },
    getFloorClass(percentLow, fantasyPosition) {
        if (!this.dsHelper) {
            return '';
        }
        return 'floor-' + this.dsHelper.getPercentLowLevel(percentLow, fantasyPosition, this.lowRangePoints);
    },
    getCeilingClass(percentHigh, fantasyPosition) {
        if (!this.dsHelper) {
            return '';
        }
        return 'ceiling-' + this.dsHelper.getPercentHighLevel(percentHigh, fantasyPosition, this.highRangePoints);
    },
});
